import { TAG_TYPES } from '../config/enums';
import { baseQueryWithTokenExpirationCheck } from '../config/query.config';
import { createApi } from '@reduxjs/toolkit/query/react';

export const baseApi = createApi({
  reducerPath: 'baseApi',
  baseQuery: baseQueryWithTokenExpirationCheck,
  tagTypes: [...TAG_TYPES],
  endpoints: () => ({}),
});